import { domReady, svgIconStr } from "../helpers"

domReady(function () {
  const btnStr = `<div class="input-group-append">
    <button class="btn btn-secondary" type="button" tabindex="-1">
      <span class="view-on">${svgIconStr("view-1")}</span>
      <span class="view-off">${svgIconStr("view-off")}</span>
  </button></div>`

  document.querySelectorAll("input[type=password]:not(.sh-field)").forEach((input) => {
    input.innerHTML += btnStr

    let wrapper = document.createElement("div")
    wrapper.classList.add("input-group", "show-hide-password")
    input.parentNode.insertBefore(wrapper, input)
    wrapper.appendChild(input)
    wrapper.innerHTML += btnStr

    const button = wrapper.querySelector("button")
    const spanOn = wrapper.querySelector("button span.view-on")
    const spanOff = wrapper.querySelector("button span.view-off")
    const field = wrapper.querySelector("input")

    button.addEventListener("click", () => {
      if (spanOff.style.display == "none" || spanOff.style.display == "") {
        spanOn.style.display = "none"
        spanOff.style.display = "inline"
        field.setAttribute("type", "text")
      } else {
        spanOn.style.display = "inline"
        spanOff.style.display = "none"
        field.setAttribute("type", "password")
      }
    })
  })
})
